import type { CountryCode } from "@config/site/types";
import { getPostalCodeValidationResult } from "@features/checkout/components/delivery-step/utils/postal-code-validation/validatePostalCode";
import type { StoreData } from "@features/stores/types";

const isPostalCodeRestricted = async (country: CountryCode, postalCode?: string) => {
    if (!postalCode) return false;
    try {
        const result = await getPostalCodeValidationResult({
            country,
            postalCode,
            isBillingForm: false,
        });
        return result?.isValid === false;
    } catch {
        // Fail open: don't block pick-up points if the restriction lookup fails
        return false;
    }
};

// Drops pick-up points located in postal codes restricted for delivery, so they can't be
// selected when searching by city name (the shop is the actual delivery destination).
export const filterRestrictedParcelShops = async (
    country: CountryCode,
    shops: StoreData[]
): Promise<StoreData[]> => {
    const restrictionFlags = await Promise.all(
        shops.map((shop) => isPostalCodeRestricted(country, shop.postalCode))
    );
    return shops.filter((_, index) => !restrictionFlags[index]);
};
